const lexicalEditor =
{
    iframeModal:
    {
        header: 'External media',
        confirm: 'OK',
        cancel: 'Cancel',
        address: 'External address'
    },
    tableModal:
    {
        header: 'Table',
        confirm: 'OK',
        cancel: 'Cancel',
        columns: 'Columns',
        rows: 'Rows'
    },
    columnsModal:
    {
        header: 'Column layout',
        layoutName: 'Predefined layouts',
        layoutValue: 'Layout definition',
        confirm: 'OK',
        cancel: 'Cancel',
        values:
        {
            '1fr 1fr': '2 columns (equal width)',
            '1fr 3fr': '2 columns (25% - 75%)',
            '1fr 1fr 1fr': '3 columns (equal width)',
            '1fr 2fr 1fr': '3 columns (25% - 50% - 25%)',
            '1fr 1fr 1fr 1fr': '4 columns (equal width)'
        }
    },
    toolbar:
    {
        undo: 'Undo',
        redo: 'Redo',
        alignmentLeft: 'Align left',
        alignmentCenter: 'Align center',
        alignmentRight: 'Align right',
        alignmentJustify: 'Justify',
        bold: 'Bold',
        italic: 'Italic',
        underline: 'Underline',
        strikethrough: 'Strikethrough',
        insertLink: 'Insert link',
        removeLink: 'Remove link',
        insertLinkPrompt: 'Enter URL:',
        insertImage: 'Insert image',
        insertExternalMedia: 'Insert external media',
        textColor: 'Text color',
        backgroundColor: 'Background color',
        clearTextColor: 'Clear text color',
        clearBackgroundColor: 'Clear background color',
        tableProperties: 'Table properties',
        blockPlaceholder: 'Block',
        fontSizePlaceholder: 'Size',
        fontFamilyPlaceholder: 'Font',
        fontSearchPlaceholder: 'Search...'
    },
    lists:
    {
        values:
        {
            'initial': 'Default',
            'circle': 'Circle',
            'square': 'Square',
            'disc': 'Disc',
            'decimal': 'Decimal',
            'decimal-leading-zero': 'Decimal with leading zeros',
            'upper-alpha': 'Upper alpha',
            'lower-alpha': 'Lower alpha',
            'upper-roman': 'Upper roman',
            'lower-roman': 'Lower roman',
            'upper-greek': 'Upper greek',
            'lower-greek': 'Lower greek',
            'none': 'None'
        }
    }
};

export default lexicalEditor;